module.exports = __webpack_public_path__ + "static/img/LUKE-TEAL.517f62d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LUKE-TEAL.jpg
// module id = 7jY1
// module chunks = 0